import { LiteratureLibraryClient } from "../../../../../Wrap/Api/Documents/LiteratureLibrary";
import { Category } from "../../../../../Wrap/Constants/Enums/Documents/Category";

export class LiteratureAction {
    public static searchDoc(search: string, docType: Category, isFavourite: boolean, callback) {
        const client = new LiteratureLibraryClient();
        const promise = client.get(search, docType, isFavourite ? isFavourite : null);
        promise.onSuccess((v) => {
            callback(v);
        });
    }

    public static setFavourite(docCode: number, isFavourite: boolean) {
        const client = new LiteratureLibraryClient();
        const promise = client.put(docCode, isFavourite);
        promise.onSuccess((v) => {});
    }
}
